var _desc, _rect, _pattern, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Background Pattern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Subtle church-themed background pattern")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 600,
    fill: "url(#bgGradient)"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "subtlePattern",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 20,
    fill: "#9EC630",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 10,
    fill: "#9EC630",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 10,
    fill: "#9EC630",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 60 L100 60 M60 20 L60 100",
    stroke: "#C8B59B",
    strokeWidth: 1,
    opacity: 0.02
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 600,
    fill: "url(#subtlePattern)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bgGradient",
    cx: "50%",
    cy: "50%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    style: {
      stopColor: "#f8f7f4",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#D4C4A0",
      stopOpacity: 0.1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.35b3af02be739acf664cecedfaf40800.svg";
export { ForwardRef as ReactComponent };